import { type FC, type JSX, type ReactNode } from 'react'
import { useFormContext } from 'react-hook-form'
import { FormattedMessage, useIntl } from 'react-intl'

import { Link } from 'base-ui'

import { LoginRegistrationOneTimePasswordInput } from '../LoginRegistrationOneTimePasswordInput/LoginRegistrationOneTimePasswordInput'

import {
  type LoginRegistrationOneTimePasswordInputFormData,
  OTP_LENGTH,
} from './loginRegistrationOneTimePasswordInputFormData'

interface LoginRegistrationOneTimePasswordCodePanelProps {
  apiErrorMessage: string | null
  onRequestNewCode: () => void
  showReRequestMessage: boolean
}

export const LoginRegistrationOneTimePasswordCodePanel: FC<
  LoginRegistrationOneTimePasswordCodePanelProps
> = ({ apiErrorMessage, onRequestNewCode, showReRequestMessage }) => {
  const i18n = useIntl()
  const {
    formState: { errors },
  } = useFormContext<LoginRegistrationOneTimePasswordInputFormData>()
  const validationError = errors.password?.message

  const codeRequestLink = (chunks: ReactNode): JSX.Element => (
    <Link
      className="cursor-pointer underline hover:text-dark-primary-max"
      data-qa-id="otp-re-request-code"
      onClick={(event) => {
        event.preventDefault()
        onRequestNewCode()
      }}
    >
      {chunks}
    </Link>
  )

  return (
    <div className="mb-5 rounded-m bg-light-primary-medium p-4">
      <h3 className="mb-4 text-m font-bold">
        <FormattedMessage id="login.otp.enterCodeHere" />
      </h3>
      <LoginRegistrationOneTimePasswordInput
        hasError={Boolean(apiErrorMessage) || Boolean(validationError)}
        length={OTP_LENGTH}
      >
        {apiErrorMessage || validationError ? (
          <span className="mt-2 text-s text-dark-error">
            {apiErrorMessage ?? validationError}
          </span>
        ) : null}
      </LoginRegistrationOneTimePasswordInput>
      {showReRequestMessage ? (
        <p className="mb-1 mt-6">
          {i18n.formatMessage(
            { id: 'login.otp.checkSpam' },
            {
              // eslint-disable-next-line id-length -- l10n parameter
              a: codeRequestLink,
            },
          )}
        </p>
      ) : null}
    </div>
  )
}
